import React from 'react';
import { Button } from 'react-bootstrap';
import { ThreeBounce } from 'better-react-spinkit';
import BasicLoader from '../../../../../util/BasicLoader';
import gqLpStyles from '../../../../LeadForm/getquote.module.css';

export default function Footer(props) {
  const prevSkipButton=()=>{
    if(props.showPrevBtn){
      return <Button
      disabled={props.isLoadingLeadForm}
      style={{padding:"10px 0", borderRadius:"4px", fontSize:"20px"}}
      onClick={() => props.handleBackClick(props.currentIndex, `${props.amplitudeEventName}_PREV_EVENT`)}
      className="sliderForm-prev btn btn-md vm-grey-btn vm-leadform-footer-prev-button">
        {props.prevBtnText ? props.prevBtnText : 'Prev'}
    </Button>
    }
    else if(props.isSkipButtonVisible){
      return(     
       <Button
      disabled={props.isLoadingLeadForm}
      style={{padding:"10px 0", borderRadius:"4px", fontSize:"20px"}}
      onClick={() => props.handleSkipButtonClick(props.currentIndex, `${props.amplitudeEventName}_SKIP_EVENT`)}
      className="sliderForm-prev btn btn-md vm-grey-btn vm-leadform-footer-prev-button">
        {props.skipButtonText ? props.skipButtonText : 'Skip'}
    </Button>
    )
    }
    else return<></>
  }
  const primaryBtnClass = gqLpStyles['gq-footer-primary-btn'];
  const primaryBtnPaddingStyle = { padding: '10px 0', borderRadius: '4px', fontSize: '20px' };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div
        className={gqLpStyles['gq-footer-actions']}
        style={{ display: 'flex', width: '100%' }}
      >
        {prevSkipButton()}
        {props.showNextBtn && props.isTriggerSlide ? (
          <Button
            disabled={props.isPlanningEvent}
            style={primaryBtnPaddingStyle}
            onClick={() => props.handleNextClick(props.currentIndex, `${props.amplitudeEventName}_PLAN_EVENT`)}
            className={`sliderForm-next btn btn-md vm-leadform-footer-find-button ${primaryBtnClass}`}
          >
            {props.isPlanningEvent ? (
              <BasicLoader color={`#fff`} size={10} />
            ) : (
              <span>{props.finalBtnText ? props.finalBtnText : 'Find Venues'}</span>
            )}
          </Button>
        ) : (
          <Button
            disabled={props.isLoadingLeadForm}
            style={primaryBtnPaddingStyle}
            onClick={() => props.handleNextClick(props.currentIndex, `${props.amplitudeEventName}_NEXT_EVENT`)}
            className={`sliderForm-next btn btn-md vm-leadform-footer-next-button ${primaryBtnClass}`}
          >
            {props.isLoadingLeadForm ? (
              <span>
                <ThreeBounce color={'#fff'} size={12} />
              </span>
            ) : props.nextBtnText ? (
              props.nextBtnText
            ) : (
              'Next'
            )}
          </Button>
        )}
      </div>
      {props.embeddedLpStyle === 'get-quote' && props.slideLength > 0 && (
        <div className={gqLpStyles['gq-embed-step-progress']} aria-hidden>
          {Array.from({ length: props.slideLength }).map((_, i) => (
            <span
              key={i}
              className={`${gqLpStyles['gq-embed-step-segment']} ${
                i <= props.currentIndex ? gqLpStyles['gq-embed-step-segment-active'] : ''
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
